import React from "react";
import {
    HomeIcon,
    StatisticsIcon,
    SettingIcon,
    LogoutIcon,
    // UserProfile
} from "../../assets/icons/icons";
import { NavLink } from "react-router-dom";

export default function Sidebar() {
    return (
        <aside className="sidebar">
            <ul>
                <div className="py-[25px]">
                    <li>
                        <NavLink
                            to="/dashboard"
                            className={({ isActive }) =>
                                `sidebar-link ${isActive ? "active" : ""}`
                            }
                        >
                            <HomeIcon className="sidebar-icon" />
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/statistics"
                            className={({ isActive }) =>
                                `sidebar-link ${isActive ? "active" : ""}`
                            }
                        >
                            <StatisticsIcon className="sidebar-icon" />
                        </NavLink>
                    </li>
                </div>
                <div className="py-[25px]">
                    <li>
                        <NavLink
                            to="/settings"
                            className={({ isActive }) =>
                                `sidebar-link ${isActive ? "active" : ""}`
                            }
                        >
                            <SettingIcon className="sidebar-icon" />
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/"
                            className={({ isActive }) =>
                                `sidebar-link ${isActive ? "active" : ""}`
                            }
                        >
                            <LogoutIcon className="sidebar-icon" />
                        </NavLink>
                    </li>
                </div>
            </ul>
        </aside>
    );
}
